const token = JSON.parse(localStorage.getItem('auth'))?.token
const decodedToken = JSON.parse(atob(token.split('.')[1]))
const userEmail = decodedToken.sub || null
const domainId = decodedToken.domainId
const domain = resolveDomain(domainId) || null

const saveImpowerXData = async (url, data, callback) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth'))?.token}`,
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      throw new Error('Failed to send data')
    }

    if (callback) {
      callback()
    }

    return response.json()
  } catch (error) {
    console.error('Error:', error)
  }
}

const getImpowerXData = async (url) => {
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth'))?.token}`,
      },
    })

    if (!response.ok) {
      throw new Error('Failed to load data')
    }

    return await response.json()
  } catch (error) {
    console.error('Error:', error)
  }
}

const deleteImpowerXData = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth'))?.token}`,
      },
    })

    if (!response.ok) {
      throw new Error('Failed to delete data')
    }

    return await response.json()
  } catch (error) {
    console.error('Error:', error)
  }
}
